import * as React from 'react'
import Button from '@doordash/component-button'
import { TemplateResponseData, CtaButtonProps } from './types'
import { useValidation } from './useValidation'
import { SubmitOnboardingCallback } from '../../pages/onboarding-workflow/OnboardingWorkflow'

type CtaButton = {
  onSubmitStep: SubmitOnboardingCallback
  templateResponseData: TemplateResponseData
  props: CtaButtonProps
}

export const CtaButton: React.FC<CtaButton> = ({
  templateResponseData,
  onSubmitStep,
  props,
}) => {
  const { validateData } = useValidation()

  const onSubmit = () => {
    if (validateData(templateResponseData)) {
      onSubmitStep(templateResponseData, {
        login: props.actions.some(
          action => action === 'UPDATE_ONBOARDING_LOGIN'
        ),
      })
    }
  }
  return (
    <Button
      data-testid="ctaButton"
      data-anchor-id="Workflow__SubmitButton"
      onClick={onSubmit}
    >
      {props.text}
    </Button>
  )
}
